var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280.423,
    height: 110.386,
    viewBox: "0 0 280.423 110.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13825",
    "data-name": "Group 13825",
    transform: "translate(-1072.244 -25.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12809",
    "data-name": "Group 12809",
    transform: "translate(1072.244 57.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-327.274,217.046h-.592c.023-.335.05-.668.05-1.01a15,15,0,0,0-15-15,15,15,0,0,0-13.984,9.6,7.364,7.364,0,0,0-5.193-2.135,7.391,7.391,0,0,0-7.39,7.392,7.375,7.375,0,0,0,.117,1.272,9.581,9.581,0,0,0-8.155,9.469,9.589,9.589,0,0,0,9.588,9.589h40.56a9.589,9.589,0,0,0,9.589-9.589A9.589,9.589,0,0,0-327.274,217.046Z",
    transform: "translate(377.422 -201.035)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12808",
    "data-name": "Group 12808",
    transform: "translate(1165.27 25.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M-220.107,251.262h-1.858c.071-1.051.157-2.1.157-3.168a47.061,47.061,0,0,0-47.059-47.059,47.04,47.04,0,0,0-43.869,30.12,23.1,23.1,0,0,0-16.289-6.7,23.187,23.187,0,0,0-23.183,23.189,23.13,23.13,0,0,0,.368,3.991,30.057,30.057,0,0,0-25.582,29.7,30.081,30.081,0,0,0,30.076,30.082h127.239a30.082,30.082,0,0,0,30.082-30.082A30.081,30.081,0,0,0-220.107,251.262Z",
    transform: "translate(377.422 -201.035)",
    fill: "#f7f7f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.8805ca7c75edb134a37ec2df76e2fcf0.svg";
export { ForwardRef as ReactComponent };